import MuiDialogContent, { DialogContentProps } from '@mui/material/DialogContent'

export function DialogContent(props: DialogContentProps) {
  return <MuiDialogContent {...props} />
}
